import { BulkOperationType } from '@ps/survey-utils';

export const DRAWABLE_BULK_OPERATIONS: BulkOperationType[] = [
  'cpi',
  'billingNumber',
  'tcReplicaLaunch',
  'status',
  'projectManager',
  'buyerProjectManager',
  'accountManager',
  'groupSurveys',
  'deleteDraft',
  'margin',
];

export const PATCHABLE_BULK_OPERATIONS: BulkOperationType[] = [
  'cpi',
  'billingNumber',
  'margin',
  'status',
  'projectManager',
  'buyerProjectManager',
  'accountManager',
];
